import { RestClient } from '@libs/rest-client';
import { OperationControl } from '../models';
import type { OperationControlRaw } from '../models';

async function fetchOperationControl() {
  return OperationControl.fromRaw(await RestClient.fa.get<OperationControlRaw>('/operation-control'));
}

export { fetchOperationControl };
